import { createSlice } from "@reduxjs/toolkit";
import { IPerson } from "../interface/IPerson";

const initialState: IPerson | null = null;

const whoamiSlice = createSlice({
    name: "whoamiTP",
    initialState,
    reducers: {
        setWhoamitStore: (state: string | null, action: any | null) => {
            return action.payload;
        },
    },
});

export const { setWhoamitStore } = whoamiSlice.actions;

export default whoamiSlice.reducer;